/**
 * search tabbed labels. on click scroll if necessary and dispatch tab-nav event
 */
import { READ_MORE_INIT_EVENT } from "../Effects/AnimateReadMore";

const TAB_NAV_PARAM = "tab-nav";
const TAB_NAV_CLASS = TAB_NAV_PARAM;
const TAB_NAV_EVENT = TAB_NAV_PARAM;
const SELECTORS = {
    CONTAINER: ".tabbed",
    SCROLLER: ".scroller",
    LABEL: ":scope > nav > div > span"
};
const ACTIVE_CLASS = "active";
const LOCATION_REG = new RegExp(`${TAB_NAV_PARAM}=([^&]*)`);

/**
 * scroll nav bar to current tab
 * @param {HTMLSpanElement} l
 */
const scrollTabs = function (l: HTMLSpanElement) {
    const p = l.closest(SELECTORS.SCROLLER);
    const rectParent = p.getBoundingClientRect();
    const rectLabel = l.getBoundingClientRect();
    if (rectLabel.x < rectParent.x || rectLabel.right > rectParent.right) {
        p.scrollTo({ left: l.offsetLeft });
    }
};

/**
 * obtain history state object
 * @param {String} id
 */
const getStateObject = function (id: string): { [key: string]: any } {
    return { ...history.state, ...{ activateTab: id } };
};

/**
 * activate tab by id
 * @param {String} id
 */
const activateTab = function (id: string): void {
    const label = document.querySelector(`[data-tab="${id}"]`) as HTMLSpanElement;
    const section = label.closest(SELECTORS.CONTAINER).querySelector(`[id*="tab-${id}"]`) as HTMLElement;

    if (label && section) {
        Array.from(label.parentElement.children).map((x) => x.classList.remove(ACTIVE_CLASS));
        Array.from(section.parentElement.children).map((x) => x.classList.remove(ACTIVE_CLASS));
        label.classList.add(ACTIVE_CLASS);
        section.classList.add(ACTIVE_CLASS);
        label.dispatchEvent(new CustomEvent("tab-active", { detail: section }));
    }
};

/**
 * obtain location search without NAV_TAB_PARAM
 * @return Array.<String>
 */
const getFilteredSearch = function (): string[] {
    return location.search
        .slice(1)
        .split("&")
        .filter((s) => s !== "" && s.split("=")[0] !== TAB_NAV_PARAM);
};

/**
 * obtain updated search string
 * @param {String} id
 * @returns {String}
 */
const getSearch = function (id: string): string {
    const search = getFilteredSearch();
    search.push(`${TAB_NAV_PARAM}=${id}`);
    return `?${search.join("&")}`;
};

const updateUrl = (id: string): void => {
    history.pushState(getStateObject(id), "", location.origin + location.pathname + getSearch(id) + location.hash);
};

const tabContainers = document.querySelectorAll(SELECTORS.CONTAINER) as NodeListOf<HTMLElement>;
tabContainers.forEach((t) => {
    const labels = t.querySelectorAll(SELECTORS.LABEL) as NodeListOf<HTMLSpanElement>;
    const withHistory = t.classList.contains(TAB_NAV_CLASS);
    // check if tab-nav parameter or active class is there or show first tab
    const tab =
        (withHistory && LOCATION_REG.exec(location.search)?.[1]) ||
        Array.from(labels).find((l) => l.classList.contains(ACTIVE_CLASS))?.dataset.tab ||
        labels[0].dataset.tab;

    if (withHistory) {
        if (tab) {
            const search = getFilteredSearch();
            search.push(`${TAB_NAV_PARAM}=${tab}`);
            updateUrl(tab);
        }
        window.addEventListener("popstate", () => {
            if (history.state?.activateTab) {
                activateTab(history.state.activateTab);
                scrollTabs(document.querySelector(`span[data-tab="${history.state.activateTab}"]`));
            }
        });
    }

    if (tab) {
        activateTab(tab);
        scrollTabs(document.querySelector(`span[data-tab="${tab}"]`));
    }

    labels.forEach((l) => {
        l.addEventListener("click", () => {
            scrollTabs(l);
            const id = l.dataset.tab;
            const tab = l.closest(SELECTORS.CONTAINER).querySelector(`[id*="tab-${id}"]`);
            activateTab(id);
            tab.dispatchEvent(new CustomEvent(TAB_NAV_EVENT, { detail: l }));
            window.dispatchEvent(new CustomEvent(READ_MORE_INIT_EVENT));
            if (withHistory) {
                const search = getFilteredSearch();
                search.push(`${TAB_NAV_PARAM}=${id}`);
                updateUrl(id);
            }
        });
    });
});

export { getStateObject, activateTab, getSearch, updateUrl, TAB_NAV_EVENT, TAB_NAV_PARAM };
